import { render, staticRenderFns } from "./PricingTooltips.vue?vue&type=template&id=28e8ce5e&scoped=true&"
import script from "./PricingTooltips.vue?vue&type=script&lang=js&"
export * from "./PricingTooltips.vue?vue&type=script&lang=js&"
import style0 from "./PricingTooltips.vue?vue&type=style&index=0&id=28e8ce5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8ce5e",
  null
  
)

export default component.exports